export const ASSISTENT_API_URL = "https://api.dev2.assistent.ai/";
//export const ASSISTENT_API_URL = "https://api.dev2.assistent.ai/";
export const ASSISTENT_API_HEADER_KEY = "r#Oa7e2)tVF!-.,m%z{OCw5S3|*nup";